<template>
    <b-table
        :data="orders"
        paginated
        :perPage="perPage"
    >
        <template>
            <b-table-column field="basket_number" :label="$t ('basket-number')" numeric sortable v-slot="props"
               v-if="columns & 0x01"
            >
                {{ props.row.basket_number }}
            </b-table-column>
            <b-table-column field="line__name" :label="$t ('production-line')" sortable v-slot="props"
               v-if="columns & 0x01"
            >
                {{ props.row.line__name }}
            </b-table-column>
            <b-table-column field="status" :label="$t ('order-status')" sortable v-slot="props"
               v-if="columns & 0x04"
            >
                {{ statusAsText [props.row.status] }}
            </b-table-column>
            <b-table-column field="XXX" :label="$t ('dealer')" sortable v-slot="props"
               v-if="columns & 0x80"
            >
                {{ dealerName (props.row) }}
            </b-table-column>
            <b-table-column field="created" :label="$t ('created')" sortable v-slot="props"
               v-if="columns & 0x02"
            >
                {{ formatdate (props.row.created) }}
            </b-table-column>
            <b-table-column field="last_status_update" :label="$t ('last_status_update')"  sortable v-slot="props"
               v-if="columns & 0x08"
            >
                {{ formatdate (props.row.last_status_update) }}
            </b-table-column>
            <b-table-column field="force_update" v-slot="props"
                v-if="columns & 0x10"
                >
                <b-tooltip :label="$t ('update-basket-status') + ' ' + formatdate (props.row.last_status_update)" :delay="500" type="is-light">
                    <b-button type="is-info"
                        :loading="props.row.query_pending"
                        icon-left="sync-alt"
                        @click="updateState (props.row.basket_number)"
                    ></b-button>
                </b-tooltip>
            </b-table-column>
            <b-table-column field="approve" v-slot="props"
                v-if="columns & 0x20"
            >
                <b-field>
                    <b-input
                        v-model="props.row.approval_number"
                        :placeholder="$t ('approval-number')"
                    ></b-input>
                    <p class="control">
                        <b-tooltip :label="$t ('approve-basket')" :delay="500" type="is-light">
                            <b-button class="button is-success"
                                :loading="props.row.query_pending"
                                icon-left="thumbs-up"
                                @click="approveState (props.row.basket_number, props.row.approval_number)"
                            ></b-button>
                        </b-tooltip>
                    </p>
                </b-field>
            </b-table-column>
            <b-table-column field="reset" v-slot="props"
                v-if="columns & 0x40"
            >
                <b-tooltip :label="$t ('reset-basket')" :delay="500" type="is-light">
                    <b-button type="is-warning"
                            @click="resetState (props.row.basket_number)"
                        :loading="props.row.query_pending"
                        icon-left="redo"
                        v-if="props.row.status > 0"
                        ></b-button>
                </b-tooltip>
            </b-table-column>
        </template>
        <template slot="empty">
            <section class="section">
                <div class="content has-text-grey has-text-centered">
                    <p>
                        <b-icon
                            icon="sad-tear"
                            size="is-large">
                        </b-icon>
                    </p>
                    <p>{{ $t ("no-orders") }}</p>
                </div>
            </section>
        </template>
    </b-table>
</template>

<script>
import Vue                  from "vue"
import { mapGetters }       from "vuex"
import axios                from "axios"

export default {
    name: "OrderTable",
    props: {
        orders:       {type: Array,  required: true},
        basketNumber: {type: String, required: true},
        perPage:      {type: Number, default:  25},
        columns:      {type: Number, default:  0xFF}
    },
    data () {
        return {
            loading: true,
        }
    },
    computed: {
        ...mapGetters(["getUserToken"]),
        statusAsText() {
            return {
                0  : this.$t ("open"),
                1  : this.$t ("?"),
                2  : this.$t ("wait for aprooval"),
                3  : this.$t ("ready"),
                4  : this.$t ("analyzing"),
                5  : this.$t ("ready for production"),
                6  : this.$t ("error")
            }
        }
    },
    methods: {
        formatdate (dateString) {
            const date = new Date (dateString)
            const day  = `${date.getFullYear ()}-${date.getMonth () + 1}-${date.getDate ()}`
            const time = `${date.getHours ()}:${date.getMinutes ()}`
            return `${day} ${time}`
        },
        dealerName (row) {
            let result = [row.dealer__billing_address__name1]
            if (row.dealer__billing_address__name2) {
                result.push (row.dealer__billing_address__name1)
            }
            result.push (row.dealer__billing_address__zip)
            result.push (row.dealer__billing_address__country)
            return result.join (" ")
        },
        findOrder (basketNumber) {
            for (let i = 0; i < this.orders.length; i++) {
                let order = this.orders [i]
                if (order.basket_number == basketNumber) {
                    return order
                }
            }
            return undefined
        },
        updateState (basketNumber) {
            const order = this.findOrder (basketNumber)
            if (order) {
                Vue.set (order, "query_pending", true)
                const uri  = `/vue/basket/${basketNumber}/status/`
                const self = this
                axios.get (uri, {
                    headers: { Authorization: "Token " + this.getUserToken}
                }).then (response => {
                    const rdata = response.data
                    if (rdata.status == false) {
                        const messages = rdata.messages.join ("<br>")
                        return self.$toastr("error", messages, self.$t("error"))
                    } else {
                        order.status             = rdata.data.order_status
                        order.last_status_update = rdata.data.last_status_update
                    }
                    order.query_pending = false
                })
            }
        },
        approveState (basketNumber, approvalNumber) {
            const order = this.findOrder (basketNumber)
            if (order) {
                Vue.set (order, "query_pending", true)
                const uri  = `/vue/basket/${basketNumber}/approve/`
                const self = this
                axios.post (uri, {}, {
                    headers: { Authorization: "Token " + this.getUserToken},
                    params: { approvalNumber}
                }).then (response => {
                    const rdata = response.data
                    order.query_pending = false
                    if (rdata.status == false) {
                        const messages = rdata.messages.join ("<br>")
                        return self.$toastr("error", messages, self.$t("error"))
                    } else {
                        order.status             = rdata.data.order_status
                        order.last_status_update = rdata.data.last_status_update
                    }
                    order.query_pending = false
                })
            }
        },
        resetState (basketNumber) {
            const order = this.findOrder (basketNumber)
            if (order) {
                Vue.set (order, "query_pending", true)
                const uri  = `/vue/basket/${basketNumber}/reset/`
                const self = this
                axios.post (uri, {}, {
                    headers: { Authorization: "Token " + this.getUserToken}
                }).then (response => {
                    const rdata = response.data
                    if (rdata.status == false) {
                        const messages = rdata.messages.join ("<br>")
                        order.query_pending = false
                        return self.$toastr("error", messages, self.$t("error"))
                    } else {
                        this.updateState (basketNumber)
                    }
                    order.query_pending = false
                })
            }
        },
    },
}
</script>

<style scoped>
    label {
        padding: 0.5em 1em;
    }
</style>